<template>
  <span v-if="onlineStatus === Starting">
    {{
      $tc("workspaces.appsGoingOnline", appsGoingToStatus(Starting), {
        appsGoingOnline: appsGoingToStatus(Starting)
      })
    }}
  </span>

  <span v-else-if="onlineStatus === Stopping">
    {{
      $tc("workspaces.appsGoingOffline", appsGoingToStatus(Stopping), {
        appsGoingOffline: appsGoingToStatus(Stopping)
      })
    }}
  </span>
</template>

<script lang="ts">
import { defineComponent, computed, PropType } from "@vue/composition-api"
import { WorkspaceOnlineStatusEnum, WorkspaceTemplate } from "@/types/workspace"

export default defineComponent({
  name: "GoingToLabel",
  props: {
    workspace: {
      type: Object as PropType<WorkspaceTemplate>,
      required: true
    }
  },
  setup(props) {
    const appsGoingToStatus = (status: WorkspaceOnlineStatusEnum) => {
      const deployedApps = props.workspace.schemaDeployed?.assets || []
      const deployedServices = props.workspace.schemaDeployed?.services || []

      return [
        ...deployedApps.filter(app => app.onlineStatus === status),
        ...deployedServices.filter(service => service.onlineStatus === status)
      ].length
    }

    const onlineStatus = computed(() => {
      return props.workspace.onlineStatus
    })

    return {
      onlineStatus,
      appsGoingToStatus,
      ...WorkspaceOnlineStatusEnum
    }
  }
})
</script>
